import {
    GET_CONFIG_FORM19,
    GET_DATOS_CIERRE,
    GET_COMBO_REGISTRAR_HITO,
    POST_ACTUALIZAR_CIERRE,
    GET_MEDIOS_PAGO,
    GET_MAX_NRO_CUOTAS,
    GET_BANCOS,
    GET_CALCULO_MONTO_CUOTA
} from '../types';
export default function cierreGestionReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM19:
            return { ...state, cfg_form19:action.payload }
        case GET_DATOS_CIERRE:
            return { ...state, datosCierreGestion:action.payload }
        case GET_COMBO_REGISTRAR_HITO:
            return { ...state, comboRegistrarHito:action.payload }
        case POST_ACTUALIZAR_CIERRE:
            return { ...state, respuestaModalCierre:action.payload }
        case GET_MEDIOS_PAGO:
            return { ...state, mediosDePago:action.payload }
        case GET_MAX_NRO_CUOTAS:
            return { ...state, maxNroCuotas:action.payload }
        case GET_BANCOS:
            return { ...state, bancos:action.payload }
        case GET_CALCULO_MONTO_CUOTA:
            return { ...state, calculoMontoCuota:action.payload }
        default:
            return state
    }
}